// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__UGfK9","tab":"Tabs_tab__3LkED","tabActive":"Tabs_tabActive__-NUrc"};